.ugc-pdp-question-and-answer-desktop-box {
  position: relative;
  margin: 0 auto;
  padding: 32px;
  min-width: 768px;
  max-width: 1440px;
}
